import cookies from './cookies'

/**
 * Utility function for handling toggle settings with cookie storage
 * @param {string} cookieName - The name of the cookie to set
 * @param {boolean} value - The toggle state (true/false)
 * @param {string} userId - The user ID for namespacing (required)
 */
export const handleToggleSetting = (cookieName, value, userId) => {
  if (!userId) {
    throw new Error('User ID is required for toggle settings')
  }

  // Set the cookie with the toggle state, namespaced with user ID in STV_{userId}_NAME format
  const namespacedCookieName = `STV_${userId}_${cookieName}`
  cookies.set(namespacedCookieName, value ? 'true' : 'false', { expires: 182 }) // 6 months expiration
}

export default {
  handleToggleSetting,
}
